import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { M_User } from '../../models/M_User';
import { CustomFile } from '../../custom-classes/CustomFile';
import { ProfilePictureService } from '../../services/profile-picture.service';
import { SessionService } from '../../services/session.service';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { IconFilledDirective } from '../../directives/icon-filled.directive';

/**
 * Component that displays the initial letter of the user who receives input.
 * If the user has an image, show the image
 *
 * This component, is comlpemented by the ProfilePictureService.
 * If the ProfilePictureService emits the event 'profileImageSubject',
 * and this component 'user' has the same id, this component image is updated.
 *
 */

@Component({
  selector: 'app-circular-letter',
  templateUrl: './circular-letter.component.html',
  styleUrls: ['./circular-letter.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, CommonModule, MatTooltip, SkeletonComponent, IconFilledDirective],
})
export class CircularLetterComponent implements OnInit {
  @Input() contentLoaded: boolean = true;
  /** User object of the component  */
  @Input() user?: M_User;
  /** Only show the ciruclar component and not the user full name */
  @Input() showFullName = true;
  /** Show the component on grayout */
  @Input() grayOut = false;
  /** Small size (24px x 24px)*/
  @Input() small = false;
  /** Big size (120px x 120px)*/
  @Input() big = false;
  /** Medius size (100px x 100px)*/
  @Input() medium = false;
  /** Check if the input user is the current logged user and shows 'TÚ'. (SessionService ID) */
  @Input() checkIsMe = true;
  /** Show user name with tooltip on hover */
  @Input() showTooltip = true;
  /** Letter box shadow */
  @Input() boxShadow = false;
  /** Upload image when user click this component. Result on 'onUploadImage' output */
  @Input() imageUpload = false;
  /** Diasble interactions with the ciruclar letter */
  @Input() disabled = false;
  /** Show edit icon */
  @Input() showEditIcon: boolean = false;
  /** Show edit icon */
  @Input() showChangeIcon: boolean = false;
  /** Put icon  */
  @Input() icon: string | undefined = undefined;
  /** Emission when user upload a image */
  @Output() onUploadImage: EventEmitter<[CustomFile, M_User]> = new EventEmitter();

  //@ViewChild(FileUploadComponent) fuc?: FileUploadComponent;

  /** Defines the background color by generating a random number from the user name.*/
  circleBackground: number | undefined;

  loadImgError = false;

  constructor(
    private profileS: ProfilePictureService,
    private sessionS: SessionService,
  ) {
    this.profileS.profileImageSubject.subscribe((data) => {
      if (this.user && this.user.id == data[1].id) {
        this.user.profile_img = data[0].src;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getColorByName();
  }

  ngOnInit(): void {
    this.getColorByName();
  }

  get hasImage() {
    return this.user && this.user.profile_img != null;
  }

  get userName() {
    return this.user ? this.user.name : '';
  }

  /** Get the first letter of the user name. If 'checkIsMe' is true, return "TÚ" if the user is the current logged user" */
  get firstLetter() {
    if (this.isMe && this.checkIsMe) {
      return 'TÚ';
    } else {
      return this.user
        ? this.user.name
          ? this.user.name.substring(0, 1).toUpperCase()
          : '?'
        : '?';
    }
  }

  get isMe() {
    if (this.user && this.sessionS.isMe(this.user.id)) {
      return true;
    }
    return false;
  }

  /** Generates a color by the user name */
  getColorByName() {
    let n = this.userName;
    if (n && n.length >= 1) {
      n = n.toLocaleLowerCase();
      let indexFirstLetter = n.charCodeAt(0) - 97;

      /** The color is the result of the combination of the first two letters index.  */
      if (n.length >= 2) {
        let indexSecondLetter = n.charCodeAt(1) - 97;
        this.circleBackground = (indexFirstLetter + indexSecondLetter + 10) % 25;
      } else {
      /** The color is the result of the first letter index.  */
        let indexFirstLetter = n.charCodeAt(0) - 97;
        this.circleBackground = (indexFirstLetter + 10) % 25;
      }
    } else {
    /** No user name, default color 99 --> var(--t) */
      this.circleBackground = 99;
    }

    /** Avoid white background on names with numbers */
    if (this.circleBackground < 0) {
      this.circleBackground = 99;
    }
  }

  /*uploadNewImage() {
    if (this.fuc && this.imageUpload) {
      this.fuc.clickInputTrigger();
    }
  }*/

  processNewUpload(cf: CustomFile) {
    if (this.user) {
      this.user.profile_img = cf.src;
      this.onUploadImage.emit([cf, this.user]);
    }
  }

  imgError() {
    this.loadImgError = true;
  }
}
